import { filterSettings as defaultFilterSettings } from "./filterSettings";

const DEFAULT_COLOR = "#8884d8";

export function getFilterDisplay(
  filterKey?: string | null,
  filterSettingsOverride?: Record<
    string,
    { name?: string; color: string }
  > | null
): { name: string; color: string } | null {
  if (!filterKey) return null;
  const settings = filterSettingsOverride || defaultFilterSettings;
  const setting = settings[filterKey];
  if (setting) {
    return {
      name: setting.name || filterKey,
      color: setting.color || DEFAULT_COLOR,
    };
  }
  return { name: filterKey, color: DEFAULT_COLOR };
}
